var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocCapture = function SvgDocCapture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 53.75v-9.375H28.75v-6.25h9.375V28.75h6.25v9.375h9.375v6.25h-9.375v9.375h-6.25Zm-37.5-9.375V28.75h6.25v9.375h9.375v6.25H.625Zm0-28.125V.625H16.25v6.25H6.875v9.375H.625Zm37.5 0V6.875H28.75V.625h15.625V16.25h-6.25Z"
  })));
};
export default SvgDocCapture;